module.exports = __webpack_public_path__ + "static/media/cu.0c1f217a.webp";